<template>
  <div @click="close" class="modal question-modal" id="question-message-modal">
    <div class="question-modal-content">
      <div @click="(e) => e.stopPropagation()" class="question-modal-body question-modal-cian">
        <h1
          class="title title--gray"
          v-text="title"/>
        <p class="subtitle question-modal-cian-subtitle" v-if="cian">Наша команда свяжется с вами в ближайшее время!</p>
        <button @click="close" v-if="cian" class="custom-button question-modal-cian-button">Ok</button>
        <button @click="close" class="question-modal-close">
          <img src="@/assets/img/X_close.svg" alt="close-icon" />
        </button>
        <img
          class="question-modal-house"
          src="@/assets/img/house-in-modal-en.svg"
          alt="house-icon"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionFormModal',

  props: {
    close: {
      default: () => null,
      type: Function,
    },
    title: {
      type: String,
      default: 'Your question has been sent successfully',
    },
    cian: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
